export enum UserRole {
    CsqAdmin = 'csqadmin',
    CsqUser = 'csquser',
    Teacher = 'teacher',
    Student = 'student',
    SuperAdmin = 'superadmin',
}